<template>
  <div v-show="isShow" class="progress-bar-container">
    <div ref="runner" :class="['runner-bar', { running: isShow }]" />
  </div>
</template>
<script>
import { ProgressBar } from '@/js/plugin';

export default {
  name: 'ProgressBar',
  data() {
    return {
      isShow: false,
    };
  },
  created() {
    this.timeoutFunc = null;
  },
  methods: {
    display(isShow) {
      if (isShow) this.show();
      else this.clear();
    },
    clear() {
      this.$refs.runner.onanimationiteration = () => {
        this.isShow = false;
        this.clearTimeoutFunc();
      };
      this.setTimeoutFunc();
    },
    show() {
      this.clearTimeoutFunc();
      this.$refs.runner.onanimationiteration = null;
      this.isShow = true;
    },
    setTimeoutFunc() {
      if (!this.timeoutFunc) {
        this.timeoutFunc = setTimeout(() => {
          this.isShow = false;
        }, 1000);
      }
    },
    clearTimeoutFunc() {
      clearTimeout(this.timeoutFunc);
      this.timeoutFunc = null;
    },
  },
  beforeMount() {
    ProgressBar.EventBus.$on('show', this.display);
  },
  beforeDestroy() {
    this.clearTimeoutFunc();
    this.$refs.runner.onanimationiteration = null;
    ProgressBar.EventBus.$off();
  },
};
</script>

<style scoped>
.progress-bar-container {
  position: fixed;
  z-index: 999;
  pointer-events: none;
  top: 0;
  right: 0;
  width: 100%;
  height: 3px;
  background-color: rgba(0, 0, 0, 0.5);
}

.runner-bar {
  height: 100%;
  width: 20%;
  background-color: #ed7e57;
}

@keyframes progress {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(500%);
    opacity: 0.75;
  }
}

.running {
  animation: progress 1s infinite ease-in;
  animation-fill-mode: both;
}
</style>
